<form class="space-y-3 sm:space-y-4 p-3 sm:p-4" (submit)="onCrear($event)">
  <!-- Código -->
  <div
    class="bg-linear-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-lg p-4 sm:p-5"
  >
    <div class="flex items-center gap-2 mb-3">
      <i class="bi bi-barcode text-blue-600 text-lg"></i>
      <label class="block text-sm sm:text-base font-bold text-gray-800">Código del Producto</label>
    </div>

    <div class="space-y-3">
      <input
        [formField]="$any(formProducto.codigo)"
        class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300 hover:border-gray-400 bg-white sm:text-base"
        placeholder="Ej: PROD-001"
      />
      @if (formProducto.codigo().touched() && formProducto.codigo().invalid()) {
        <small class="text-sm text-red-600 text-xs block mt-1">{{
          formProducto.codigo().errors() | formErrorMessage
        }}</small>
      }

      <div class="flex items-center gap-3 pt-2 border-t border-blue-100">
        <input
          type="checkbox"
          [checked]="generarCodigo()"
          (change)="onChangeGenerarCodigo($event.target.checked)"
          id="generarCodigoAuto"
          class="w-4 h-4 cursor-pointer accent-blue-600"
        />
        <label for="generarCodigoAuto" class="inline-flex items-center cursor-pointer flex-1">
          <span class="text-xs sm:text-sm text-gray-700 font-medium"
            >Generar código automáticamente</span
          >
        </label>
      </div>
    </div>
  </div>

  <!-- Nombre -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Nombre</label>
    <input
      [formField]="$any(formProducto.nombre)"
      class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300 hover:border-gray-400 bg-white sm:text-base"
      [class.border-red-500]="formProducto.nombre().touched() && formProducto.nombre().invalid()"
      placeholder="Ingrese el nombre del producto"
    />
    @if (formProducto.nombre().touched() && formProducto.nombre().invalid()) {
      <small class="text-sm text-red-600 text-xs block mt-1">{{
        formProducto.nombre().errors() | formErrorMessage
      }}</small>
    }
  </div>

  <!-- Descripción -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Descripción</label>
    <textarea
      rows="3"
      [formField]="$any(formProducto.descripcion)"
      class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none border-gray-300 hover:border-gray-400 bg-white sm:text-base"
      [class.border-red-500]="
        formProducto.descripcion().touched() && formProducto.descripcion().invalid()
      "
      placeholder="Ingrese una descripción"
    ></textarea>
    @if (formProducto.descripcion().touched() && formProducto.descripcion().invalid()) {
      <small class="text-sm text-red-600 text-xs block mt-1">{{
        formProducto.descripcion().errors() | formErrorMessage
      }}</small>
    }
  </div>

  <!-- Precio Venta y Base -->
  <div>
    <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
      <div class="flex-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Precio Venta</label>
        <app-input-number
          [formField]="$any(formProducto.precio_venta)"
          styleClass="w-full"
          placeholder="0.00"
        />
      </div>
      <div class="flex-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Precio Base</label>
        <app-input-number
          [formField]="$any(formProducto.precio_base)"
          styleClass="w-full"
          placeholder="0.00"
        />
      </div>
    </div>
    <div class="flex flex-col gap-1 mt-1">
      @if (formProducto.precio_venta().touched() && formProducto.precio_venta().invalid()) {
        <small class="text-sm text-red-600 text-xs">{{
          formProducto.precio_venta().errors() | formErrorMessage
        }}</small>
      }
      @if (formProducto.precio_base().touched() && formProducto.precio_base().invalid()) {
        <small class="text-sm text-red-600 text-xs">{{
          formProducto.precio_base().errors() | formErrorMessage
        }}</small>
      }
    </div>
  </div>

  <!-- Precio Venta Sucursal -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
      >Precio en esta sucursal <span class="text-gray-400 font-normal">(opcional)</span></label
    >
    <app-input-number
      [formField]="$any(formProducto.precio_venta_sucursal)"
      styleClass="w-full"
      placeholder="Dejar vacío para usar precio global"
    />
    <small class="text-gray-400 text-xs block mt-1"
      >Si se deja vacío, se usará el Precio Venta global para esta sucursal.</small
    >
  </div>

  <!-- Unidad de Medida -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Unidad de Medida</label>
    <app-select
      [filter]="true"
      filterBy="label,value"
      [emptyFilterMessage]="'No se encontraron unidades.'"
      [formField]="$any(formProducto.unidad_medida)"
      [options]="opcionesTipoUnidad()"
      [loading]="!opcionesTipoUnidad().length"
      styleClass="w-full"
    />
  </div>

  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
    <!-- Stock -->
    <div class="flex-1">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Stock</label>
      <app-input-number
        [formField]="$any(formProducto.stock)"
        styleClass="w-full"
        placeholder="0"
      />
      @if (formProducto.stock().touched() && formProducto.stock().invalid()) {
        <small class="text-sm text-red-600 text-xs block mt-1">{{
          formProducto.stock().errors() | formErrorMessage
        }}</small>
      }
      @if (crearConStockCero()) {
        <small class="text-xs text-blue-600 block mt-1">
          El producto se creará con stock 0 y este stock se ingresará como movimiento de inventario
          al confirmar la creación.
        </small>
      }
    </div>

    <!-- Categoría -->
    <div class="flex-1">
      <div class="flex items-center gap-2 mb-1">
        <label class="text-xs sm:text-sm font-medium text-gray-700">Categoría</label>
        <button
          type="button"
          class="text-xs text-blue-600 hover:text-blue-800 font-medium"
          (click)="modalCrearCategoria.set(true)"
        >
          Crear +
        </button>
      </div>
      <app-select
        [filter]="true"
        filterBy="label,value"
        [emptyFilterMessage]="'No se encontraron categorías.'"
        [formField]="$any(formProducto.categoria_id)"
        [options]="opcionesCategorias()"
        [showClear]="true"
        styleClass="w-full"
      />
    </div>
  </div>

  <!-- Imagen -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Imagen</label>
    <div class="flex items-center gap-4">
      <app-producto-avatar
        [maxSizeMb]="maxImageSizeMb()"
        (imagenChange)="onChildImagenChange($event)"
        (validationError)="imagenError.set($event)"
      ></app-producto-avatar>
      <div class="flex-1">
        <p class="text-xs sm:text-sm text-gray-700 font-medium">Click en el círculo para cargar</p>
        <small class="text-gray-500 text-xs block mt-1"
          >Formato: JPG, PNG o WEBP. Máximo: {{ maxImageSizeMb() }}MB</small
        >
        @if (imagenArchivo()) {
          <small class="text-green-600 text-xs block mt-1">{{ imagenArchivo()!.name }}</small>
        }
      </div>
    </div>
    @if (imagenError()) {
      <small class="text-sm text-red-600 text-xs block mt-1">{{ imagenError() }}</small>
    }
  </div>

  <!-- Tipo de Producto -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Tipo de Producto</label>
    <app-select
      [options]="opcionesTipoProducto()"
      [formField]="$any(formProducto.tipo_producto)"
      (onChange)="onTipoProductoChange($event)"
      styleClass="w-full"
    />
  </div>

  <!-- Controlar Stock + Es Servicio -->
  <div class="flex flex-col sm:flex-row gap-2 sm:gap-4 flex-wrap">
    <label
      class="inline-flex items-center"
      [class.cursor-not-allowed]="isTipoReceta()"
      [class.opacity-60]="isTipoReceta()"
    >
      <input
        type="checkbox"
        [formField]="$any(formProducto.controlar_stock)"
        class="h-4 w-4 rounded border-gray-300 accent-blue-600"
        [class.cursor-not-allowed]="isTipoReceta()"
      />
      <span class="ml-2 text-xs sm:text-sm">
        Controlar Stock
        @if (isTipoReceta()) {
          <span class="text-gray-400">(no aplica para recetas)</span>
        }
      </span>
    </label>
    @if (isTipoProducto()) {
      <label class="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          [formField]="$any(formProducto.es_servicio)"
          class="h-4 w-4 rounded border-gray-300 accent-blue-600 cursor-pointer"
        />
        <span class="ml-2 text-xs sm:text-sm">Es Servicio</span>
      </label>
    }
  </div>

  <!-- Opciones de Servicio -->
  @if (formProducto.es_servicio().value() == true) {
    <div class="border-t pt-3 sm:pt-4 mt-3 sm:mt-4">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-2"
        >Opciones de Servicio</label
      >
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
        <label class="inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            [formField]="$any(formProducto.es_gestion_tiempo)"
            class="h-4 w-4 rounded border-gray-300 accent-blue-600 cursor-pointer"
          />
          <span class="ml-2 text-xs sm:text-sm">Gestionar por tiempo</span>
        </label>
        @if (formProducto.es_gestion_tiempo().value() == true) {
          <div>
            <label class="block text-xs text-gray-500 mb-1">Duración (minutos)</label>
            <input
              type="number"
              [formField]="$any(formProducto.duracion_minutos)"
              class="w-full sm:w-24 px-2 py-1 border rounded text-sm"
              placeholder="60"
            />
          </div>
        }
      </div>
    </div>
  }

  <!-- Ingredientes (solo tipo Receta) -->
  @if (isTipoReceta()) {
    <div class="border-t pt-3 sm:pt-4 mt-3 sm:mt-4" (click)="cargarIngredientes()">
      <div class="flex justify-between items-center mb-3">
        <h3 class="text-sm font-semibold text-gray-800">Ingredientes de la receta</h3>
        <app-button
          label="Agregar"
          icon="bi bi-plus"
          variant="info"
          size="sm"
          (onClick)="agregarIngrediente()"
        />
      </div>
      @if (ingredientes.length > 0) {
        <div class="flex flex-col gap-2">
          @for (ing of ingredientes; track ing.tempId; let i = $index) {
            <div class="flex items-center gap-2 p-2 bg-gray-50 rounded border border-gray-200">
              <div class="flex-1 min-w-0">
                <app-select
                  [options]="opcionesProductosIngrediente()"
                  [value]="ing.producto"
                  (onChange)="ing.producto = $event; onIngredienteSeleccionado(i)"
                  placeholder="Ingrediente"
                  [filter]="true"
                  [compareWith]="compareProductoById"
                  filterBy="nombre,codigo"
                  styleClass="w-full"
                />
              </div>
              <div class="w-16">
                <app-input-number
                  [value]="ing.cantidad"
                  (valueChange)="ing.cantidad = $event"
                  [min]="0"
                  placeholder="Cant."
                  styleClass="w-full"
                />
              </div>
              <div class="w-32">
                <app-select
                  [options]="unidadesCompatiblesParaIngrediente(ing)"
                  [value]="ing.unidad"
                  (onChange)="ing.unidad = $event; onUnidadIngredienteCambiada(i)"
                  styleClass="w-full"
                />
              </div>
              <div class="w-20 text-right text-xs text-gray-500">
                @if (ing.costoUnitario > 0) {
                  S/ {{ ing.costoUnitario | number: '1.2-4' }}
                }
              </div>
              <app-button
                icon="bi bi-x-lg"
                variant="danger"
                [rounded]="true"
                size="sm"
                (onClick)="removerIngrediente(i)"
              />
            </div>
          }
        </div>
      } @else {
        <div class="text-center text-gray-400 py-3 border border-dashed border-gray-300 rounded">
          <p class="text-xs">Agrega ingredientes para esta receta</p>
        </div>
      }
      @if (ingredientes.length > 0) {
        <div class="flex justify-end pt-2">
          <span class="text-xs font-bold"
            >Costo estimado: S/ {{ costoTotal() | number: '1.2-2' }}</span
          >
        </div>
      }
    </div>
  }

  <div class="flex flex-col-reverse sm:flex-row justify-end gap-2 pt-3 sm:pt-4 border-t">
    <button
      type="button"
      class="w-full sm:w-auto px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-sm sm:text-base transition-colors"
      (click)="onCerrar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="formProducto().invalid()"
    >
      Guardar
    </button>
  </div>
</form>
<app-dialog
  header="Crear Nueva Categoría"
  [(visible)]="modalCrearCategoria"
  (onHide)="modalCrearCategoria.set(false)"
  size="sm"
>
  @if (modalCrearCategoria()) {
    <app-crear-categoria (cerrar)="onCrearCategoriaCerrada($event)" />
  }
</app-dialog>